import { of } from 'rxjs';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, catchError, exhaustMap } from 'rxjs/operators';
import { ActionTypes, PurchaseFi2Xml } from '@appStore/products/actions';
import * as actions from '@appStore/products/actions';
import { ProductsService } from '@appStore/products/services/product.service';

@Injectable()
export class ProductsEffects {
  constructor(private productsService: ProductsService, private actions$: Actions) {}

  loadProducts$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ActionTypes.ProductsLoad),
      exhaustMap(action => {
        return this.productsService.getProducts().pipe(
          map(product => new actions.ProductsLoadSuccess(product)),
          catchError(error => of(new actions.ProductsLoadFail(error)))
        );
      })
    );
  });
  
  
  purchaseFi2Xml$ = createEffect(() => {
    return  this.actions$.pipe(
      ofType(ActionTypes.PurchaseFi2Xml),
      exhaustMap((action: PurchaseFi2Xml) => {
        return this.productsService.purchaseFi2Xml(action.payload).pipe(
          map(item => new actions.PurchaseFi2XmlSuccess(item)),
          catchError(error => of(new actions.PurchaseFi2XmlFail(error)))
        );
      })
    );
  });
  
  
  isRegisteredOnCustomer$ = createEffect(() => {
    return  this.actions$.pipe(
      ofType(ActionTypes.IsFi2XmlRegisteredOnCustomer),
      map((action: actions.IsFi2XmlRegisteredOnCustomer) => action.payload),
      exhaustMap(item =>
        this.productsService.getIsFi2XmlRegisteredOnCustomer(item).pipe(
          map(registeredItem => new actions.IsFi2XmlRegisteredOnCustomerSuccess(registeredItem)),
          catchError(error => of(new actions.IsFi2XmlRegisteredOnCustomerFail(error)))
        )
      )
    );
  });
}
